<script>
    import Checkbox from './Checkbox.svelte';

    let { checked = $bindable(false), disabled = false, children } = $props();
</script>

<label>
    <Checkbox bind:checked {disabled} />
    <span>
        {@render children?.()}
    </span>
</label>

<style>
    label {
        display: grid;
        grid-template-columns: auto 1fr;
        gap: 0.75em;
        align-items: start;
        cursor: pointer;
    }

    label:global(:has(input[type="checkbox"]:disabled)) > span {
        opacity: 0.5;
        cursor: not-allowed;
    }

    label > span {
        line-height: 1.4;
        margin-top: 4px;
    }

    label > span :global(small) {
        color: #666;
        font-size: 0.9em;
        display: block;
        margin-top: 0.25em;
    }
</style>